import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { RoleAuthService, UserRole } from './role-auth.service';

@Injectable({ providedIn: 'root' })
export class RoleGuard implements CanActivate {
  constructor(private readonly authService: RoleAuthService, private readonly router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    const user = this.authService.getCurrentUser();
    if (!user) return this.router.createUrlTree(['/login'], { queryParams: { returnUrl: state.url } });

    const allowedRoles = (route.data['roles'] || []) as UserRole[];
    if (!allowedRoles.length || allowedRoles.includes(user.role)) return true;

    return this.router.parseUrl(this.authService.getDashboardRoute(user.role));
  }
}
